<template>
  <div>
    <section>
      <v-snackbar v-model="snackbar.model" timeout="3000">{{
        snackbar.text
      }}</v-snackbar>
    </section>
    <section>
      <template>
        <v-container>
          <v-row justify="center" align="center">
            <v-col cols="12">
              <v-form
                v-model="form1.isValid"
                @submit.prevent="updateStaleReportReminderConfig"
              >
                <Subheader
                  icon="mdi-bell-alert"
                  title="Erinnerungen für unvollständige Dienstberichte"
                ></Subheader>
                <div class="mt-7">
                  <v-card :loading="loading" :disabled="form1.isLoading">
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            <v-checkbox
                              v-model="
                                dutyManagementConfig.staleReportReminder
                                  .isActive
                              "
                              label="Erinnerungen für unvollständige Dienstberichte versenden"
                              hint="Wenn aktiviert, werden automatisch Erinnerungen per E-Mail versendet, wenn Dienstberichte nach einer festgelegten Zeit nicht abgeschlossen wurden."
                              persistent-hint
                            ></v-checkbox>
                          </v-col>

                          <v-col
                            v-if="
                              dutyManagementConfig.staleReportReminder.isActive
                            "
                            cols="12"
                            md="6"
                          >
                            <v-text-field
                              v-model.number="
                                dutyManagementConfig.staleReportReminder
                                  .thresholdHours
                              "
                              type="number"
                              min="1"
                              outlined
                              label="Schwellenwert (Stunden)"
                              hint="Anzahl der Stunden, nach denen ein unvollständiger Bericht als überfällig gilt."
                              persistent-hint
                              :rules="[rules.required, rules.minValue(1)]"
                            ></v-text-field>
                          </v-col>

                          <v-col
                            v-if="
                              dutyManagementConfig.staleReportReminder.isActive
                            "
                            cols="12"
                            md="6"
                          >
                            <v-text-field
                              v-model.number="
                                dutyManagementConfig.staleReportReminder
                                  .reminderIntervalDays
                              "
                              type="number"
                              min="1"
                              outlined
                              label="Erinnerungsintervall (Tage)"
                              hint="Anzahl der Tage zwischen wiederholten Erinnerungen."
                              persistent-hint
                              :rules="[rules.required, rules.minValue(1)]"
                            ></v-text-field>
                          </v-col>

                          <v-col
                            v-if="
                              dutyManagementConfig.staleReportReminder.isActive
                            "
                            cols="12"
                          >
                            <div class="subtitle-2 mb-4">
                              Benachrichtigungslogik
                            </div>
                            <v-card outlined class="mb-4">
                              <v-card-text>
                                <div class="body-2 grey--text text--darken-1">
                                  <p class="mb-2">
                                    <strong
                                      >Berichtsverantwortliche Person wird immer
                                      benachrichtigt:</strong
                                    >
                                  </p>
                                  <ul class="ml-4">
                                    <li>
                                      Bei Status "In Bearbeitung": Person im
                                      Feld "Berichtsverantwortlich"
                                    </li>
                                    <li>
                                      Bei Status "In Korrektur": Person im Feld
                                      "Korrekturverantwortlich"
                                    </li>
                                  </ul>
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-col>

                          <v-col
                            v-if="
                              dutyManagementConfig.staleReportReminder.isActive
                            "
                            cols="12"
                          >
                            <v-autocomplete
                              v-model="
                                dutyManagementConfig.staleReportReminder
                                  .additionalNotifyPersons
                              "
                              :items="membershipsListFiltered"
                              chips
                              small-chips
                              outlined
                              deletable-chips
                              label="Zusätzlich zu benachrichtigende Personen"
                              hint="Diese Personen werden zusätzlich zur verantwortlichen Person über unvollständige Berichte benachrichtigt."
                              persistent-hint
                              item-text="user.displayName"
                              item-value="user.uid"
                              multiple
                              clearable
                              hide-details="auto"
                            >
                            </v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-container>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          depressed
                          color="success"
                          :loading="form1.isLoading"
                          @click="updateStaleReportReminderConfig()"
                        >
                          <v-icon left> mdi-content-save </v-icon>
                          Speichern
                        </v-btn>
                      </v-card-actions>
                    </v-card-text>
                  </v-card>
                </div>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
  </div>
</template>

<script>
import Subheader from "@/components/_systemwide/Subheader.vue";
import { DUTY_MANAGEMENT, ADMIN } from "@/store/modules.js";
import {
  UPDATE_DUTY_MANAGEMENT_CONFIG,
  GET_USER_LIST,
} from "@/store/action-types";

export default {
  name: "duty-management-config-tab-general",
  components: {
    Subheader,
  },
  data() {
    return {
      loading: false,
      snackbar: {
        model: false,
        text: "",
      },
      form1: {
        isValid: false,
        isLoading: false,
      },
      rules: {
        required: (value) => !!value || "Feld ist erforderlich.",
        minValue: (min) => (value) =>
          value >= min || `Wert muss mindestens ${min} sein.`,
      },
    };
  },
  computed: {
    dutyManagementConfig() {
      const config =
        this.$store.state.organization.activeOrganization.config.dutyManagement;
      // Ensure staleReportReminder has default values for backward compatibility
      if (!config.staleReportReminder) {
        config.staleReportReminder = {
          isActive: false,
          thresholdHours: 24,
          reminderIntervalDays: 3,
          additionalNotifyPersons: [],
        };
      }
      return config;
    },
    memberships() {
      return this.$store.state.admin.membershipsPublic;
    },
    membershipsListFiltered() {
      const input = this.memberships;
      const groupItems = (arr) => {
        return arr.reduce((a, c) => {
          if (typeof a[c.group.title] === "undefined") a[c.group.title] = [];
          a[c.group.title] = [...a[c.group.title], c];
          return a;
        }, {});
      };
      const grouped = groupItems(input);
      const output = [];
      Object.keys(grouped).forEach((key) => {
        output.push({ header: key });
        grouped[key].forEach((entry) => {
          output.push(entry);
        });
      });
      return output;
    },
  },
  created() {
    this.$store.dispatch(`${ADMIN}${GET_USER_LIST}`, {
      organizationId: this.$route.params.organizationId,
      queryIsFiltered: true,
      query: {
        type: "active",
      },
    });
  },
  methods: {
    updateStaleReportReminderConfig() {
      this.form1.isLoading = true;
      this.$store
        .dispatch(`${DUTY_MANAGEMENT}${UPDATE_DUTY_MANAGEMENT_CONFIG}`, {
          organizationId: this.$route.params.organizationId,
          type: "onlyStaleReportReminderConfig",
          staleReportReminder: this.dutyManagementConfig.staleReportReminder,
        })
        .then(() => {
          this.form1.isLoading = false;
          this.snackbar.model = true;
          this.snackbar.text = "Einstellungen erfolgreich aktualisiert.";
        })
        .catch((error) => {
          console.log(error);
          this.form1.isLoading = false;
          this.snackbar.model = true;
          this.snackbar.text = error.message;
        });
    },
  },
};
</script>

<style scoped></style>
